import React, { PureComponent } from 'react';

class CategoryFilter extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			isOptionShow: false
		};

		this.setWrapperRef = this.setWrapperRef.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
		this.hidePopup = this.hidePopup.bind(this);
		this.handleEscButtonPress = this.handleEscButtonPress.bind(this);
	}

	setWrapperRef(node) {
		this.wrapperRef = node;
	}

	handleClickOutside(event) {
		if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
			this.setState({isOptionShow: false});
			this.hidePopup();
		}
	}

	hidePopup() {
		this.setState({isOptionShow: false});
	}

	handleEscButtonPress(e) {
		e.key == 'Escape' && (this.hidePopup());
	}

	componentDidMount() {
		document.addEventListener('keydown', this.handleEscButtonPress);
		document.addEventListener('click', this.handleClickOutside);
	}

	componentWillUnmount() {
		document.removeEventListener('keydown', this.handleEscButtonPress);
		document.removeEventListener('click', this.handleClickOutside);
	}

	render() {
		const { intl, categories, selected, toggleCategoryItem } = this.props;

		return (
			<div
				style={{ position: 'relative' }}
				className='single-filter__container'
				ref={this.setWrapperRef}
			>
				<div
					className={`controls__slide-down ${this.state.isOptionShow ? 'active' : ''}`}
					onClick={() => { this.setState(state => ({ isOptionShow: !state.isOptionShow })); }}
				>
					<span>{intl('Categories')}</span>
					<span>{selected.length || null}</span>
					<span className={`arrow-dropdown ${this.state.isOptionShow && 'active'}`} />
				</div>
				{this.state.isOptionShow && (
					<div
						className='select-items-container'
						style={{ position: 'absolute', top: '31px', paddingTop: '5px', width: '100%', zIndex: '1000' }}
					>
						{categories.map((category) => (
							<div
								className={`filter-option ${selected.includes(category.id) ? 'active' : '' }`}
								onClick={() => toggleCategoryItem(category.id)}
								key={category.id}
							>
								{category[`name_${intl.language}`]}
							</div>
						))}
					</div>
				)}
			</div>
		);
	}
}

export default CategoryFilter;


// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/market/components/store/category-filter.js